import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7931ef96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","padding-right":"10px"} }
const _hoisted_2 = { class: "acoes-relatorio" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.computedCodigoSelecionado,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
      loading: _ctx.state.buscandoDados,
      placeholder: _ctx.state.buscandoDados ? 'Carregando...' : _ctx.props.placeholder,
      disabled: _ctx.props.disabled || _ctx.state.buscandoDados,
      allowClear: _ctx.props.limparSelecao,
      "show-search": true,
      "filter-option": false,
      "option-filter-prop": "label",
      class: "ss-tamanho-completo",
      onChange: _ctx.change,
      onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarRelatorio($event))),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false))
    }, _createSlots({
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecionarBase.listaItensConsultaRapida, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.codigo,
            value: item.codigo,
            label: item.textoIdentificacao
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(item.textoIdentificacao), 1),
                _createElementVNode("span", _hoisted_2, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-text",
                    title: "Editar Layout",
                    onClick: _withModifiers(($event: any) => (_ctx.onEdit(item)), ["stop"])
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_3),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-text",
                    title: "Excluir Layout",
                    onClick: _withModifiers(($event: any) => (_ctx.onDelete(item)), ["stop"]),
                    style: {"margin-left":"8px"}
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_4)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["value", "label"]))
        }), 128))
      ]),
      _: 2
    }, [
      (_ctx.state.buscandoDados)
        ? {
            name: "notFoundContent",
            fn: _withCtx(() => [
              _createTextVNode(" Buscando Relatórios "),
              _createVNode(_component_a_spin, { size: "small" })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["value", "loading", "placeholder", "disabled", "allowClear", "onChange"])
  ]))
}